import { useState } from "react";
import { faqs } from "@/mocks/homeContent";
import { SectionHead } from "./Common";

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20 scroll-mt-16 md:scroll-mt-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="container-page grid grid-cols-1 gap-8 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <div className="lg:sticky lg:top-28">
            <SectionHead
              eyebrow="FAQ · 常见问题"
              title="关于每日黑料，你想知道的都在这里"
              desc="针对内容来源、信息准确性、投稿反馈、转载授权与更新节奏等常见疑问，我们在此统一解答。"
            />
            <a
              href="#contact"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              还有其他疑问？留言告诉我们
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="lg:col-span-3 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={
                  "overflow-hidden rounded-lg ring-1 transition-colors " +
                  (open ? "bg-background-100 ring-primary-300" : "bg-background-100/60 ring-background-300/50")
                }
              >
                <button
                  onClick={() => setOpenIdx(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6 md:py-5"
                >
                  <span className="font-heading text-[15px] font-bold leading-snug text-foreground-900 md:text-lg">{f.q}</span>
                  <span
                    className={
                      "flex h-8 w-8 flex-none items-center justify-center rounded-full transition-colors " +
                      (open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600")
                    }
                  >
                    <i className={open ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {open && (
                  <div className="px-5 pb-5 md:px-6 md:pb-6">
                    <p className="border-t border-background-300/60 pt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}